export const SET_FORMS_LIST = 'SET_FORMS_LIST';
export const SET_QUESTIONS_LIST = 'SET_QUESTIONS_LIST';
export const SET_CURRENT_FORM_ID = 'SET_CURRENT_FORM_ID';
export const SET_ERRORS = 'SET_ERRORS';
